import { Box, Button, CircularProgress, Switch, Typography } from "@mui/material";
import { PinnacleTextField } from "../../../components/PinnacleTextField";
import { E_FIELD_REQUIRED } from "../../../utils/constants";
import { Program } from "../../../api/interfaces/Program";
import { FormData } from "../hooks/useUserForm";

interface CreateUserDrawerContentProps {
  formData: FormData;
  touchedFields: Record<keyof FormData, boolean>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur: (field: keyof FormData) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  programs: Program[];
  isFormValid: () => boolean;
}

const CreateUserDrawerContent: React.FC<CreateUserDrawerContentProps> = ({
  formData,
  touchedFields,
  onChange,
  onBlur,
  onSubmit,
  isSubmitting,
  isFormValid
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <PinnacleTextField
        label="Email address"
        name="email"
        value={formData.email}
        onChange={onChange}
        fullWidth
        onBlur={() => onBlur('email')}
        error={touchedFields.email && !formData.email.trim()}
        helperText={
          touchedFields.email && !formData.email.trim()
            ? E_FIELD_REQUIRED
            : ' '
        }
        disabled={isSubmitting}
      />

       <Box
        display="flex"
        alignItems="left"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography variant="body1" sx={{ color: '#333533', fontWeight: '600' }}>
          Settings
        </Typography>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Typography variant="body2" sx={{ color: '#818181' }}>
          Set the user as an <Box component="span" sx={{ fontWeight: 'bold' }}>ADMIN</Box> of the application?
        </Typography>

        <Switch
          checked={formData.isAdmin}
          onChange={onChange}
          disabled={isSubmitting || formData.isTrial}
          name="isAdmin"
        />
      </Box>

      <Button
        variant="contained"
        color="primary"
        onClick={onSubmit}
        disabled={isSubmitting || !isFormValid()}
        startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
      >
        ADD USER
      </Button>
    </Box>
  );
};

export default CreateUserDrawerContent;